import DeviceRegistrations from './registrations';
import DeviceRegistrationView from './registration_view';
import DeviceRegistrationAdd from './registration_add';

export {
  DeviceRegistrations, 
  DeviceRegistrationView, 
  DeviceRegistrationAdd
};
